import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 88,
	height: 88,
	viewBox: "0 0 88 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2079_19552)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M78.8334 84.3332C78.8334 82.3081 80.475 80.6665 82.5 80.6665C84.5251 80.6665 86.1667 82.3081 86.1667 84.3332V87.9998H78.8334V84.3332Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.916626 82.9582C0.916626 81.6925 1.94264 80.6665 3.20829 80.6665C4.47395 80.6665 5.49996 81.6925 5.49996 82.9582V87.0832H0.916626V82.9582Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9808 18.2266C10.8807 17.3359 11.4261 17.8178 11.4388 17.8291C13.1175 17.9825 12.8919 18.364 12.3939 21.1426C11.8968 23.9224 11.0814 19.1283 10.9808 18.2266ZM4.58142 15.9053C5.2794 14.8548 5.53447 15.6503 5.53455 15.6504C5.53455 15.6504 5.7232 15.7952 6.26892 16.4355C6.8145 17.0756 5.50571 17.8994 4.49939 18.5234C3.49519 19.1459 3.09543 19.1836 3.36072 18.707C3.62717 18.2291 3.88417 16.9554 4.58142 15.9053ZM15.3998 15.2646C15.7941 14.8004 16.1809 14.9517 16.1869 14.9541C18.0107 17.267 15.8679 16.591 15.2885 16.3506C14.7104 16.1103 15.0023 15.7324 15.3998 15.2646ZM9.77478 6.41504C10.8441 6.06322 13.7363 7.06372 14.7357 10.4307C15.7035 13.6923 13.4742 15.4042 10.8627 15.9629L10.6097 16.0137C7.89079 16.5141 5.85567 13.9502 5.66052 10.6572C5.46749 7.37887 9.73701 6.42343 9.77478 6.41504ZM2.60291 9.98047C3.56619 10.0229 3.11826 11.0041 3.0697 11.7266C3.02023 12.4494 2.46631 12.2492 1.33923 11.8037C0.211584 11.3585 -0.453999 10.9471 0.362671 10.6768C1.17901 10.4071 2.276 9.96621 2.60291 9.98047ZM16.3988 10.5674C16.3692 9.60975 17.2032 9.8608 17.2113 9.86328C22.8419 9.87067 20.5535 10.3688 18.3734 11.2061C16.1944 12.0432 16.4295 11.5302 16.3988 10.5674ZM15.9574 4.27539C16.3583 4.12971 16.4608 4.39402 16.2318 4.59277C16.0019 4.79203 15.199 6.29038 14.6976 7.03125C14.1962 7.7718 13.4965 6.71484 13.4965 6.71484C12.2937 5.46925 15.9574 4.27539 15.9574 4.27539ZM2.27283 3.88867C1.83448 3.5264 3.46108 3.90974 4.71423 4.92578C4.71423 4.92578 5.69804 5.98978 5.26892 6.42285C4.84148 6.8554 4.14219 6.90451 3.69275 6.24316C3.24409 5.58131 2.70948 4.25159 2.27283 3.88867ZM6.34998 0.604492C5.94992 -1.21298 7.93649 1.57937 8.47107 2.29004C9.0056 3.0015 9.22502 3.92408 7.8949 4.45801C6.5651 4.99158 6.76306 3.15137 6.76306 3.15137C6.76286 3.14145 6.74647 2.40901 6.34998 0.604492Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: .916667,
				height: 9.16667,
				transform: "matrix(-0.913545 -0.406737 -0.406737 0.913545 59.9352 23.21)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-5-inside-1_2079_19552",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M79.7496 74.8599V76.9995H50.4166L28.4166 25.6665H58.6666L79.7496 74.8599Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79.7496 74.8599V76.9995H50.4166L28.4166 25.6665H58.6666L79.7496 74.8599Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79.7496 74.8599H80.6663V74.6717L80.5922 74.4988L79.7496 74.8599ZM79.7496 76.9995V77.9162H80.6663V76.9995H79.7496ZM50.4166 76.9995L49.5741 77.3606L49.8122 77.9162H50.4166V76.9995ZM28.4166 25.6665V24.7498H27.0265L27.5741 26.0276L28.4166 25.6665ZM58.6666 25.6665L59.5092 25.3054L59.2711 24.7498H58.6666V25.6665ZM79.7496 74.8599H78.833V76.9995H79.7496H80.6663V74.8599H79.7496ZM79.7496 76.9995V76.0828H50.4166V76.9995V77.9162H79.7496V76.9995ZM50.4166 76.9995L51.2592 76.6384L29.2592 25.3054L28.4166 25.6665L27.5741 26.0276L49.5741 77.3606L50.4166 76.9995ZM28.4166 25.6665V26.5832H58.6666V25.6665V24.7498H28.4166V25.6665ZM58.6666 25.6665L57.8241 26.0276L78.9071 75.221L79.7496 74.8599L80.5922 74.4988L59.5092 25.3054L58.6666 25.6665Z",
				fill: "black",
				mask: "url(#path-5-inside-1_2079_19552)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 50.875,
				y: 76.5418,
				width: 28.4167,
				height: 11,
				fill: "#8588D8",
				stroke: "black",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.833 70.1245H34.833C35.5923 70.1245 36.2078 70.7403 36.208 71.4995V87.5415H22.458V71.4995C22.4582 70.7404 23.0739 70.1247 23.833 70.1245Z",
				fill: "white",
				stroke: "black",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 29.3333,
				cy: 62.3332,
				r: 3.20833,
				fill: "white",
				stroke: "black",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.8754 77.0933V87.5415H7.79138V77.0933L29.3334 26.8286L50.8754 77.0933Z",
				fill: "white",
				stroke: "black",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0833 76.9998L30.25 29.3332L29.3333 27.0415L8.25 76.9998V87.0832H10.0833V76.9998Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 27.3584,
				y: 23.1768,
				width: .916667,
				height: 9.16667,
				transform: "rotate(-23 27.3584 23.1768)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 56.6918,
				y: 23.1768,
				width: .916667,
				height: 9.16667,
				transform: "rotate(-23 56.6918 23.1768)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: .916667,
				height: 4.51118,
				transform: "matrix(-0.913545 -0.406737 -0.406737 0.913545 31.5184 23.21)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.667 73.7915H33C33.2531 73.7915 33.458 73.9974 33.458 74.2505V87.5415H25.208V74.2505C25.208 73.9974 25.4139 73.7915 25.667 73.7915Z",
				fill: "black",
				stroke: "black",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.4972 65.6599C32.738 66.2621 32.2945 66.917 31.646 66.917H27.0208C26.3723 66.917 25.9289 66.262 26.1697 65.6599L28.4827 59.8779C28.79 59.1096 29.8776 59.1096 30.1849 59.878L32.4972 65.6599ZM27.8654 64.7699C27.6479 65.3678 28.0906 66 28.7268 66H30.2921C30.9407 66 31.3842 65.3449 31.1432 64.7427L30.3233 62.6941C30.0106 61.9128 28.8986 61.9305 28.6108 62.7213L27.8654 64.7699Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 59.125,
				y: 59.1248,
				width: 20.1667,
				height: 28.4167,
				fill: "white",
				stroke: "#4F49BA",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-18-inside-2_2079_19552",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M79.75 58.605V59.5835H58.667L41.9375 46.1997L41.5088 44.9165H66.917L79.75 58.605Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79.75 58.605V59.5835H58.667L41.9375 46.1997L41.5088 44.9165H66.917L79.75 58.605Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79.75 58.605H80.6667V58.2425L80.4187 57.978L79.75 58.605ZM79.75 59.5835V60.5002H80.6667V59.5835H79.75ZM58.667 59.5835L58.0943 60.2993L58.3454 60.5002H58.667V59.5835ZM41.9375 46.1997L41.0681 46.4902L41.1537 46.7466L41.3649 46.9155L41.9375 46.1997ZM41.5088 44.9165V43.9998H40.2361L40.6394 45.207L41.5088 44.9165ZM66.917 44.9165L67.5857 44.2896L67.3141 43.9998H66.917V44.9165ZM79.75 58.605H78.8333V59.5835H79.75H80.6667V58.605H79.75ZM79.75 59.5835V58.6668H58.667V59.5835V60.5002H79.75V59.5835ZM58.667 59.5835L59.2396 58.8677L42.5101 45.4839L41.9375 46.1997L41.3649 46.9155L58.0943 60.2993L58.667 59.5835ZM41.9375 46.1997L42.8069 45.9092L42.3782 44.626L41.5088 44.9165L40.6394 45.207L41.0681 46.4902L41.9375 46.1997ZM41.5088 44.9165V45.8332H66.917V44.9165V43.9998H41.5088V44.9165ZM66.917 44.9165L66.2483 45.5435L79.0813 59.2319L79.75 58.605L80.4187 57.978L67.5857 44.2896L66.917 44.9165Z",
				fill: "#4F49BA",
				mask: "url(#path-18-inside-2_2079_19552)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.9072 49.3654C62.6917 49.3654 66.5456 50.9617 68.5145 52.9306L74.6719 59.0881H64.588L58.4305 52.9306C56.4616 50.9617 57.1228 49.3654 59.9072 49.3654Z",
				stroke: "#4F49BA",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .391212,
				y: .162045,
				width: 9.625,
				height: .458333,
				transform: "matrix(1 0 0.707107 0.707107 57.3011 52.1588)",
				fill: "black",
				stroke: "#4F49BA",
				strokeWidth: .458333
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .391212,
				y: .162045,
				width: .458333,
				height: 13.5051,
				transform: "matrix(1 0 0.707107 0.707107 59.0104 49.089)",
				fill: "black",
				stroke: "#4F49BA",
				strokeWidth: .458333
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-23-inside-3_2079_19552",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M59.5834 59.1245V87.9995H54.5414V76.5415L41.4398 44.9165H41.8226L59.5834 59.1245Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5834 59.1245V87.9995H54.5414V76.5415L41.4398 44.9165H41.8226L59.5834 59.1245Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5834 59.1245H60.5V58.6839L60.156 58.4087L59.5834 59.1245ZM59.5834 87.9995V88.9162H60.5V87.9995H59.5834ZM54.5414 87.9995H53.6247V88.9162H54.5414V87.9995ZM54.5414 76.5415H55.458V76.3591L55.3883 76.1907L54.5414 76.5415ZM41.4398 44.9165V43.9998H40.0678L40.5929 45.2673L41.4398 44.9165ZM41.8226 44.9165L42.3953 44.2007L42.1442 43.9998H41.8226V44.9165ZM59.5834 59.1245H58.6667V87.9995H59.5834H60.5V59.1245H59.5834ZM59.5834 87.9995V87.0828H54.5414V87.9995V88.9162H59.5834V87.9995ZM54.5414 87.9995H55.458V76.5415H54.5414H53.6247V87.9995H54.5414ZM54.5414 76.5415L55.3883 76.1907L42.2867 44.5657L41.4398 44.9165L40.5929 45.2673L53.6945 76.8923L54.5414 76.5415ZM41.4398 44.9165V45.8332H41.8226V44.9165V43.9998H41.4398V44.9165ZM41.8226 44.9165L41.25 45.6323L59.0108 59.8403L59.5834 59.1245L60.156 58.4087L42.3953 44.2007L41.8226 44.9165Z",
				fill: "#4F49BA",
				mask: "url(#path-23-inside-3_2079_19552)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 62.7917,
				y: 68.2918,
				width: 4.58333,
				height: 10.0833,
				rx: .458333,
				stroke: "#4F49BA",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 71.0417,
				y: 68.2918,
				width: 4.58333,
				height: 10.0833,
				rx: .458333,
				stroke: "#4F49BA",
				strokeWidth: .916667
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45.8334 21.0835H53.1667V32.0835L50.4167 26.5835H45.8334V21.0835Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.41663 85.7085C6.41663 84.9491 7.03223 84.3335 7.79163 84.3335C8.55102 84.3335 9.16663 84.9491 9.16663 85.7085V88.0002H6.41663V85.7085Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 54.0834,
				y: 87.0835,
				width: 25.6667,
				height: .916667,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 54.5416,
				y: 76.0835,
				width: .916667,
				height: 11,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 54.0834,
				y: 76.0835,
				width: .916667,
				height: .916667,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: 87.0835,
				width: 88,
				height: .916667,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M39.923 12.3638C40.1563 11.5599 41.1418 11.2746 41.79 11.7674C42.5939 10.3152 44.9278 10.8597 44.9019 12.5972C46.3282 12.5713 46.017 14.8532 44.6426 14.4642C44.2794 15.1903 43.32 15.3199 42.7494 14.7754C42.2567 15.7609 40.7526 15.5793 40.5193 14.4642C38.367 15.683 37.5889 12.5194 39.9228 12.3637L39.923 12.3638Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M82.0797 22.4771C81.7078 21.1588 80.0853 20.6855 79.0374 21.5307C77.7192 19.1645 73.8992 20.0434 73.9671 22.8827C71.601 22.8489 72.108 26.601 74.3728 25.9249C74.9813 27.108 76.3671 27.3447 77.3812 26.4995C77.4827 26.6347 77.5502 26.7361 77.6517 26.8376C78.8348 28.0882 81.1333 27.4461 81.3024 25.9249C82.2826 26.6347 84.2094 26.1278 84.2432 24.4376C84.2769 23.5927 83.229 22.3756 82.0799 22.477L82.0797 22.4771Z",
				fill: "#8588D8"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2079_19552",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 88,
			height: 88,
			fill: "white"
		})
	}) })]
});
export default SvgHomeLight;
